import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import GuardianView from './guardian.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';
import GuardianDashboardView from './sub-modules/dashboard/guardianDashboard.view';
import GuardianAcademicView from './sub-modules/academic/guardianAcademic.view';
import GuardianFeesView from './sub-modules/fees/guardianFees.view';
import GuardianTransportView from './sub-modules/transport/guardianTransport.view';
import GuardianDocumentsView from './sub-modules/documents/guardianDocuments.view';
import GuardianEventsCommunicationView from './sub-modules/eventsCommunication/guardianEventsCommunication.view';
import GuardianTimetableView from './sub-modules/academic/subviews/timetable/guardianTimetable.view';
import GuardianCoursesClassesView from './sub-modules/academic/subviews/coursesClasses/guardianCoursesClasses.view';
import GuardianLessonPlansView from './sub-modules/academic/subviews/lessonPlans/guardianLessonPlans.view';
import GuardianAssessmentsView from './sub-modules/academic/subviews/assessments/guardianAssessments.view';
import GuardianHomeworkView from './sub-modules/academic/subviews/homework/guardianHomework.view';
import GuardianAttendanceView from './sub-modules/academic/subviews/attendance/guardianAttendance.view';
import GuardianLibraryView from './sub-modules/academic/subviews/library/guardianLibrary.view';
import GuardianMaterialsView from './sub-modules/academic/subviews/materials/guardianMaterials.view';
import GuardianEventsView from './sub-modules/eventsCommunication/subviews/events/guardianEvents.view';
import GuardianCommunicationsView from './sub-modules/eventsCommunication/subviews/communications/guardianCommunications.view';
import GuardianConcernsView from './sub-modules/concerns/GuardianConcernsView.view';
import GuardianProfileView from './sub-modules/profile/guardianProfile.view';
import GuardianSettingsView from './sub-modules/settings/guardianSettings.view';
import { GuardianProvider } from './contexts/guardian.context';

const useGuardianRoutes = () => {
  const dashboardPath = pages.guardian.subPages?.dashboard?.path?.replace(/^\//, '') || 'dashboard';
  const academicsPath = pages.guardian.subPages?.academics?.path?.replace(/^\//, '') || 'academics';
  const feesPath = pages.guardian.subPages?.fees?.path?.replace(/^\//, '') || 'fees';
  const transportPath = pages.guardian.subPages?.transport?.path?.replace(/^\//, '') || 'transport';
  const documentsPath = pages.guardian.subPages?.document?.path?.replace(/^\//, '') || 'documents';
  const eventsCommPath = pages.guardian.subPages?.['events-communication']?.path?.replace(/^\//, '') || 'events-communication';
  const concernsPath = pages.guardian.subPages?.concerns?.path?.replace(/^\//, '') || 'concerns';
  const profilePath = pages.guardian.subPages?.profile?.path?.replace(/^\//, '') || 'profile';
  const settingsPath = pages.guardian.subPages?.settings?.path?.replace(/^\//, '') || 'settings';

  const academicSubPages = pages.guardian.subPages?.academics?.subPages;
  const schedulePath = academicSubPages?.schedule?.path?.replace(/^\//, '') || 'schedule';
  const curriculumPath = academicSubPages?.curriculum?.path?.replace(/^\//, '') || 'curriculum';
  const lessonPlansPath = academicSubPages?.lessonPlans?.path?.replace(/^\//, '') || 'lesson-plans';
  const assessmentsPath = academicSubPages?.assessments?.path?.replace(/^\//, '') || 'assessments';
  const homeworkPath = academicSubPages?.homework?.path?.replace(/^\//, '') || 'homework';
  const attendancePath = academicSubPages?.attendance?.path?.replace(/^\//, '') || 'attendance';
  const libraryPath = academicSubPages?.library?.path?.replace(/^\//, '') || 'library';
  const materialsPath = academicSubPages?.materials?.path?.replace(/^\//, '') || 'materials';

  return (
    <Route
      path={pages.guardian.path}
      element={(
        <GuardianProvider>
          <GuardianView />
        </GuardianProvider>
      )}
    >
      <Route
        index
        element={
          <ProtectedRoute module="guardian" submodule="dashboard">
            <GuardianDashboardView />
          </ProtectedRoute>
        }
      />
      <Route
        path={dashboardPath}
        element={
          <ProtectedRoute module="guardian" submodule="dashboard">
            <GuardianDashboardView />
          </ProtectedRoute>
        }
      />
      <Route
        path={academicsPath}
        element={
          <ProtectedRoute module="guardian" submodule="academicsSchedule">
            <GuardianAcademicView />
          </ProtectedRoute>
        }
      >
        <Route
          index
          element={<GuardianTimetableView />}
        />
        <Route
          path={schedulePath}
          element={<GuardianTimetableView />}
        />
        <Route
          path={curriculumPath}
          element={<GuardianCoursesClassesView />}
        />
        <Route
          path={lessonPlansPath}
          element={<GuardianLessonPlansView />}
        />
        <Route
          path={materialsPath}
          element={<GuardianMaterialsView />}
        />
        <Route
          path={assessmentsPath}
          element={<GuardianAssessmentsView />}
        />
        <Route
          path={homeworkPath}
          element={<GuardianHomeworkView />}
        />
        <Route
          path={attendancePath}
          element={<GuardianAttendanceView />}
        />
        <Route
          path={libraryPath}
          element={<GuardianLibraryView />}
        />
      </Route>
      <Route
        path={feesPath}
        element={
          <ProtectedRoute module="guardian" submodule="fees">
            <GuardianFeesView />
          </ProtectedRoute>
        }
      />
      <Route
        path={transportPath}
        element={
          <ProtectedRoute module="guardian" submodule="transport">
            <GuardianTransportView />
          </ProtectedRoute>
        }
      />
      <Route
        path={documentsPath}
        element={
          <ProtectedRoute module="guardian" submodule="documents">
            <GuardianDocumentsView />
          </ProtectedRoute>
        }
      />
      <Route
        path={eventsCommPath}
        element={
          <ProtectedRoute module="guardian" submodule="eventsCommunication">
            <GuardianEventsCommunicationView />
          </ProtectedRoute>
        }
      >
        <Route
          index
          element={<GuardianEventsView />}
        />
        <Route
          path={pages.guardian.subPages?.['events-communication']?.subPages?.events?.path?.replace(/^\//, '') || 'events'}
          element={<GuardianEventsView />}
        />
        <Route
          path={pages.guardian.subPages?.['events-communication']?.subPages?.communications?.path?.replace(/^\//, '') || 'communications'}
          element={<GuardianCommunicationsView />}
        />
      </Route>
      <Route
        path={concernsPath}
        element={
          <ProtectedRoute module="guardian" submodule="concerns">
            <GuardianConcernsView />
          </ProtectedRoute>
        }
      />
      <Route
        path={profilePath}
        element={
          <ProtectedRoute module="guardian" submodule="profile">
            <GuardianProfileView />
          </ProtectedRoute>
        }
      />
      <Route
        path={settingsPath}
        element={
          <ProtectedRoute module="guardian" submodule="settings">
            <GuardianSettingsView />
          </ProtectedRoute>
        }
      />
    </Route>
  );
};

export default useGuardianRoutes;
